






























































import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import { RelatedDocumentViewModel, SalesPackTabModel, StoreConstants } from '@/types';
import { BvTableFieldArray } from 'bootstrap-vue';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'SalesPack',
  props: {
    salesPacks: {
      type: Array as () => SalesPackTabModel[],
      required: true
    },
    isSubmitting: {
      type: Boolean,
      required: true
    },
    isWorkflowJobLocked: {
      type: Boolean,
      required: true
    },
    isJobLoading: {
      type: Boolean,
      default: false
    },
    tabDescription: {
      type: String,
      default: 'Sales Pack'
    },
    authorizeWithOnFido: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    ...mapActions(StoreConstants.DocumentView.ModuleName, [
      StoreConstants.DocumentView.Actions.SetRelatedDocumentBeingViewed
    ]),
    previewSalesPack(): void {
      this.$emit('preview-sales-pack');
    },
    signSalesPack(): void {
      this.$emit('sign-sales-pack');
    },
    onSalesPackChecked(salesPackDocument: SalesPackTabModel, checked: boolean): void {
      if (!this.isWorkflowJobLocked) {
        this.$emit('on-sales-pack-checked', salesPackDocument.documentTypeId, checked);
      }
    },
    getIcon(this: any, salesPackTabModel: SalesPackTabModel) {
      if (
        salesPackTabModel.isWorkflowJobDocument ||
        (salesPackTabModel.relatedDocument != null &&
          salesPackTabModel.relatedDocument?.documentSearchModel.documentId ===
            (this[StoreConstants.DocumentView.Getters.RelatedDocumentBeingViewed] as RelatedDocumentViewModel)
              ?.documentSearchModel?.documentId)
      ) {
        return 'file';
      }

      return 'paperclip';
    },
    getButtonVariant(this: any, salesPackTabModel: SalesPackTabModel) {
      if (
        salesPackTabModel.isWorkflowJobDocument ||
        (salesPackTabModel.relatedDocument != null &&
          salesPackTabModel.relatedDocument?.documentSearchModel.documentId ===
            (this[StoreConstants.DocumentView.Getters.RelatedDocumentBeingViewed] as RelatedDocumentViewModel)
              ?.documentSearchModel?.documentId)
      ) {
        return 'outline-info';
      }

      return 'info';
    },
    viewDocumentButtonClicked(this: any, salesPackTabModel: SalesPackTabModel) {
      if (
        (salesPackTabModel.isWorkflowJobDocument &&
          this[StoreConstants.DocumentView.Getters.IsRelatedDocumentBeingViewed]) ||
        (salesPackTabModel.relatedDocument != null &&
          salesPackTabModel.relatedDocument?.documentSearchModel.documentId ===
            (this[StoreConstants.DocumentView.Getters.RelatedDocumentBeingViewed] as RelatedDocumentViewModel)
              ?.documentSearchModel?.documentId)
      ) {
        this[StoreConstants.DocumentView.Actions.SetRelatedDocumentBeingViewed]({});
      } else if (
        salesPackTabModel.relatedDocument?.documentSearchModel.documentId !==
        (this[StoreConstants.DocumentView.Getters.RelatedDocumentBeingViewed] as RelatedDocumentViewModel)
          ?.documentSearchModel?.documentId
      ) {
        this[StoreConstants.DocumentView.Actions.SetRelatedDocumentBeingViewed](salesPackTabModel.relatedDocument);
      }
    },
    onOnfidoChecked(checked: boolean): void {
      this.$emit('on-onfido-checked', checked);
    }
  },

  computed: {
    ...mapGetters(StoreConstants.DocumentView.ModuleName, [
      StoreConstants.DocumentView.Getters.RelatedDocumentBeingViewed,
      StoreConstants.DocumentView.Getters.IsRelatedDocumentBeingViewed
    ]),
    items(this: any) {
      return this.salesPacks.map((x: SalesPackTabModel) => ({ ...x }));
    },
    atLeastOneSalesPackDocumentSelected() {
      return Boolean(this.salesPacks.find((x) => x.include));
    }
  },
  created(this: any) {
    this.salesPackColumns = [
      { key: 'include' },
      { key: 'mstoreRowName', label: 'Document Type' },
      { key: 'view' },
      { key: 'comments' }
    ] as BvTableFieldArray;
  },
  components: {
    MStoreSpinnerButton
  }
});
